__turbopack_context__.v({
  "container": "XTc7lW_container",
  "pickedUp": "XTc7lW_pickedUp",
  "ready": "XTc7lW_ready",
});
